webpackJsonp([2],{

/***/ 1032:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var platform_browser_dynamic_1 = __webpack_require__(159);
var login_module_1 = __webpack_require__(1033);
var platform = platform_browser_dynamic_1.platformBrowserDynamic();
platform.bootstrapModule(login_module_1.AppModule);


/***/ }),

/***/ 1033:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var platform_browser_1 = __webpack_require__(35);
var forms_1 = __webpack_require__(30);
var material_1 = __webpack_require__(6);
var flex_layout_1 = __webpack_require__(179);
var animations_1 = __webpack_require__(183);
var http_1 = __webpack_require__(9);
__webpack_require__(86);
var login_panelComponent_1 = __webpack_require__(1034);
var core_2 = __webpack_require__(2);
core_2.enableProdMode();
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    AppModule = __decorate([
        core_1.NgModule({
            imports: [platform_browser_1.BrowserModule, forms_1.FormsModule, material_1.MaterialModule, flex_layout_1.FlexLayoutModule, animations_1.BrowserAnimationsModule, http_1.HttpModule],
            declarations: [login_panelComponent_1.LoginPanelComponent],
            bootstrap: [login_panelComponent_1.LoginPanelComponent]
        })
    ], AppModule);
    return AppModule;
}());
exports.AppModule = AppModule;


/***/ }),

/***/ 1034:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(2);
var http_1 = __webpack_require__(9);
var LoginPanelComponent = /** @class */ (function () {
    function LoginPanelComponent(http) {
        this.http = http;
        this.LS = {};
        this.Languages = [];
        this.message = "";
        this.loading = false;
    }
    LoginPanelComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.get("./Account/GetLanguages", { headers: headers })
            .map(function (res) { return res.json(); }).subscribe(function (res) {
            _this.LanguageId = res.languageId;
            _this.Languages = res.languages;
        }, function (error) {
        }, function () {
            _this.onChangeLanguage();
        });
    };
    LoginPanelComponent.prototype.enter = function (event) {
        var _this = this;
        if (!this.login) {
            return;
        }
        this.loading = true;
        this.message = '';
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post("./Account/LogOn", JSON.stringify({ userName: this.login, password: this.password }), { headers: headers })
            .map(function (res) { return res.json(); }).subscribe(function (res) {
            if (res.result == 'ok') {
                window.location.href = "../";
            }
            else if (res.result == 'error') {
                _this.message = "".concat.apply("", res.message.split("$").map(function (t) { return t in _this.LS ? _this.LS[t] : t; }));
                _this.loading = false;
            }
        }, function (error) {
            _this.loading = false;
        }, function () {
            //completed
        });
    };
    LoginPanelComponent.prototype.onChangeLanguage = function () {
        var _this = this;
        var headers = new http_1.Headers();
        headers.append('Content-Type', 'application/json');
        this.http.post("./Account/GetLocalizationStrings", JSON.stringify({ id: this.LanguageId }), { headers: headers })
            .map(function (res) { return res.json(); }).subscribe(function (res) {
            _this.LS = res;
            document.getElementById('bodyId').style.backgroundImage = "url('../images/" + _this.LS._lang + "/login_bg_" + _this.getScreenClass() + ".jpg')";
        }, function (error) {
            console.log(error);
        }, function () {
            //completed
        });
    };
    LoginPanelComponent.prototype.getScreenClass = function () {
        var date = new Date();
        var day = date.getDay();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        if (day >= 1 && day <= 5) {
            if (hours >= 8 && hours <= 20)
                return "day";
            else
                return "night";
        }
        else {
            if ((hours >= 9 || (hours >= 8 && minutes >= 30)) && hours <= 18)
                return "day";
            else
                return "night";
        }
    };
    ;
    LoginPanelComponent = __decorate([
        core_1.Component({
            selector: 'login-panel',
            templateUrl: './app/templates/login/login.panelComponent.html'
        }),
        __metadata("design:paramtypes", [http_1.Http])
    ], LoginPanelComponent);
    return LoginPanelComponent;
}());
exports.LoginPanelComponent = LoginPanelComponent;


/***/ })

},[1032]);


// WEBPACK FOOTER //
// login.js